import React from 'react';
import { useCart } from '../context/CartContext';
import '../App.css';

const CartPage = () => {
  const { 
    cart, 
    removeFromCart, 
    updateQuantity, 
    clearCart, 
    getTotalPrice,
    getTotalItems 
  } = useCart();

  if (cart.length === 0) {
    return (
      <div className="cart-page">
        <div className="container">
          <h2>Košarica</h2>
          <div className="empty-cart">
            <p>Vaša košarica je prazna.</p>
            <a href="/" className="btn">Nastavi sa kupovinom</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="container">
        <h2>Košarica ({getTotalItems()} proizvoda)</h2>
        
        <div className="cart-items">
          {cart.map((item) => (
            <div key={item.id} className="cart-item">
              <img src={item.image} alt={item.name} className="cart-item-image" />
              
              <div className="cart-item-info">
                <h4>{item.name}</h4>
                <p className="category">{item.category}</p>
                <p className="price">{item.price} eur</p>
              </div>
              
              <div className="cart-item-controls">
                <div className="quantity-controls">
                  <button 
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    className="quantity-btn"
                  >
                    -
                  </button>
                  <span className="quantity">{item.quantity}</span>
                  <button 
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    className="quantity-btn"
                  >
                    +
                  </button>
                </div>
                
                <button 
                  onClick={() => removeFromCart(item.id)}
                  className="remove-btn"
                >
                  Ukloni
                </button>
              </div>
              
              <div className="cart-item-total">
                {(item.price * item.quantity).toFixed(2)} eur
              </div>
            </div>
          ))}
        </div>
        
        <div className="cart-summary">
          <div className="total-price">
            <h3>Ukupno: {getTotalPrice().toFixed(2)} eur</h3>
          </div>
          
          <div className="cart-actions">
            <button onClick={clearCart} className="btn btn-secondary">
              Isprazni košaricu
            </button>
            <button className="btn btn-primary">
              Nastavi sa plaćanjem
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;